'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPuzzle = function TiPuzzle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.1 18.8c0.6 0 1.2 0.2 1.6 0.6 0.9 0.6 1.3-0.1 1.3-0.6v-3c0-1.3-1.1-2.5-2.5-2.5h-4.6c-0.6 0-1.2-0.3-0.6-1.2 0.4-0.5 0.6-1.1 0.6-1.7 0-1.6-1.7-2.9-3.7-2.9s-3.8 1.3-3.8 2.9c0 0.5 0.2 1 0.4 1.4 0.9 1.1 0.3 1.5-0.4 1.5h-4.6c-1.3 0-2.5 1.2-2.5 2.5v2.9c0 0.7 0.5 1.3 1.6 0.5 0.4-0.3 0.9-0.5 1.4-0.5 1.6 0 2.9 1.7 2.9 3.8s-1.3 3.7-2.9 3.7c-0.7 0-1.2-0.2-1.7-0.6-0.9-0.6-1.3 0.1-1.3 0.6v4.6c0 1.4 1.2 2.5 2.5 2.5h4.6c0.7 0 1.3-0.4 0.4-1.5-0.2-0.4-0.4-0.9-0.4-1.4 0-1.6 1.7-2.9 3.8-2.9s3.7 1.3 3.7 2.9c0 0.6-0.2 1.2-0.6 1.7-0.6 0.9 0 1.2 0.6 1.2h4.6c1.4 0 2.5-1.1 2.5-2.5v-4.5c0-0.7-0.4-1.3-1.5-0.5-0.5 0.3-0.9 0.5-1.4 0.5-1.6 0-2.9-1.7-2.9-3.8s1.3-3.7 2.9-3.7z' })
        )
    );
};

exports.default = TiPuzzle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/puzzle.js
// module id = 3727
// module chunks = 0